import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  suppliers: [],
  selectedSupplier: null,
  currentPage: 1,
  totalPages: 1,
  totalDocuments: 0,
  isSupplierCreated: false,
  loading: false,
  isSupplierCancelled: false,
  isCustomerEdited: false,
  error: null,
};

const suppliersSlice = createSlice({
  name: 'suppliers',
  initialState,
  reducers: {
    fetchSuppliersRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuppliersSuccess(state, action) {
      state.loading = false;
      state.suppliers = action.payload.suppliers;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalDocuments = action.payload.totalDocuments;
    },
    fetchSuppliersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchSupplierById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSupplierByIdSuccess(state, action) {
      state.loading = false;
      state.selectedSupplier = action.payload;
    },
    fetchSupplierByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createSupplierRequest(state) {
      state.loading = true;
      state.error = null;
      state.isSupplierCreated = false;
    },
    createSupplierSuccess(state) {
      state.loading = false;
      state.error = false;
      state.isSupplierCreated = true;
    },
    createSupplierFailure(state, action) {
      state.loading = false;
      state.isSupplierCreated = false;
      state.error = action.payload;
    },
    editSupplierRequest(state) {
      state.loading = true;
      state.error = null;
      state.isSupplierEdited = false;
    },
    editSupplierFailure(state, action) {
      console.log(action);
      state.loading = false;
      state.isBSupplierEdited = false;
      state.error = action.payload;
    },
    editSupplierSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isSupplierEdited = true;
    },
    cancelSupplierCreate(state) {
      state.loading = false;
      state.error = null;
      state.isSupplierCreated = false;
    },
    markSupplierCreated(state, action) {
      state.isSupplierCreated = action.payload;
    },
    markSupplierEdited(state, action) {
      state.isSupplierEdited = action.payload;
    },
    resetSelectedSupplier(state) {
      state.selectedSupplier = null;
    },
  },
});

export const {
  fetchSuppliersRequest,
  fetchSuppliersSuccess,
  fetchSuppliersFailure,
  fetchSupplierById,
  fetchSupplierByIdSuccess,
  fetchSupplierByIdFailure,
  createSupplierRequest,
  createSupplierSuccess,
  createSupplierFailure,
  editSupplierRequest,
  editSupplierFailure,
  editSupplierSuccess,
  markSupplierCreated,
  markSupplierEdited,
  cancelSupplierCreate,
  resetSelectedSupplier,
} = suppliersSlice.actions;

export default suppliersSlice.reducer;
